import { useState, useEffect } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  Divider,
  TextField,
  Typography,
} from "@mui/material";

const BulkProductUpdateModal = ({
  type,
  open,
  setOpen,
  handleBulkQuantity,
  minQty = 0,
}) => {
  const [updateQty, setUpdateQty] = useState("");

  // ✅ Reset input every time modal opens
  useEffect(() => {
    if (open) setUpdateQty("");
  }, [open]);

  // ✅ Pass type as param — avoids stale state issue in parent
  const handleConfirm = () => {
    if (type === "UPDATE") {
      const parsed = parseInt(updateQty, 10);
      handleBulkQuantity(parsed, "UPDATE");
    } else {
      handleBulkQuantity(0, "REMOVE");
    }
  };

  return (
    // ✅ Guard via open && !!type — no early return before hooks
    <Dialog
      open={open && !!type}
      onClose={() => setOpen(false)}
      PaperProps={{
        sx: {
          borderRadius: "12px",
          padding: "24px",
          width: "320px",
          maxWidth: "90vw",
        },
      }}
    >
      <Typography
        sx={{
          fontSize: "14px",
          fontWeight: 600,
          color: "#1B1B1B",
          textAlign: "center",
          mb: 1.5,
        }}
      >
        {type === "UPDATE" ? "Enter Quantity" : "Are you sure to remove?"}
      </Typography>

      <Divider />

      <DialogContent sx={{ px: 0, pb: 0 }}>
        {type === "UPDATE" ? (
          <TextField
            fullWidth
            placeholder={`Minimum Quantity: ${minQty}`}
            variant="outlined"
            size="small"
            value={updateQty}
            onChange={(e) => setUpdateQty(e.target.value)}
            inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
            sx={{
              my: 2,
              "& .MuiOutlinedInput-root": {
                borderRadius: "8px",
                fontSize: "12px",
              },
            }}
          />
        ) : (
          <Box sx={{ my: 1.5 }} />
        )}

        <Box display="flex" justifyContent="space-around" gap={2}>
          <Button
            fullWidth
            variant="text"
            onClick={() => setOpen(false)}
            sx={{
              fontSize: "14px",
              fontWeight: 600,
              color: "#1B1B1B",
              textTransform: "none",
            }}
          >
            Cancel
          </Button>
          <Button
            fullWidth
            variant="contained"
            onClick={handleConfirm}
            sx={{
              fontSize: "14px",
              fontWeight: 600,
              backgroundColor: "#FF272F",
              borderRadius: "8px",
              textTransform: "none",
              "&:hover": { backgroundColor: "#e0181f" },
            }}
          >
            {type === "UPDATE" ? "Ok" : "Yes"}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default BulkProductUpdateModal;